import { useEffect, useState } from "react";
import { SG_CURRENCY, SG_ENV, SG_GAMES, SG_JURISDICTION, SG_LANGUAGES, SG_NYXROOT, SG_OPIDS } from "./LWServices";
import { getCookie, setCookie } from "../Services/cookies";

const LW = ({ authenticated }) => {
    const [gameList, setGameList] = useState([]);

    const [game, setGame] = useState(getCookie("lwGame") ? getCookie("lwGame") : "Select Game_0");
    const [currency, setCurrency] = useState(getCookie("lwCurrency") ? getCookie("lwCurrency") : "GBP");
    const [language, setLanguage] = useState(getCookie("lwLanguage") ? getCookie("lwLanguage") : "en_gb");
    const [opid, setOpid] = useState(getCookie("lwOpid") ? getCookie("lwOpid") : SG_OPIDS[0].id);
    const [sessionId, setSessionId] = useState(getCookie("lwSessionId") ? getCookie("lwSessionId") : "");
    const [mode, setMode] = useState(getCookie("lwMode") ? getCookie("lwMode") : "demo");
    const [device, setDevice] = useState(getCookie("lwDevice") ? getCookie("lwDevice") : "desktop");
    const [env, setEnv] = useState(getCookie("lwEnv") ? getCookie("lwEnv") : "Forge");
    const [server, setServer] = useState(getCookie("lwServer") ? getCookie("lwServer") : SG_NYXROOT[0].code);
    const [jurisdiction, setJurisdiction] = useState(
        getCookie("lwJurisdiction") ? getCookie("lwJurisdiction") : ".com",
    );
    const [hideRTP, setHideRTP] = useState(getCookie("lwHideRTP") ? getCookie("lwHideRTP") === "true" : false);
    const [clock, setClock] = useState(getCookie("lwClock") ? getCookie("lwClock") === "true" : false);
    const [grub, setGrub] = useState(getCookie("lwGrub") ? getCookie("lwGrub") === "true" : false);

    useEffect(() => {
        setCookie("lwGame", game);
    }, [game]);

    useEffect(() => {
        setCookie("lwCurrency", currency);
    }, [currency]);

    useEffect(() => {
        setCookie("lwLanguage", language);
    }, [language]);

    useEffect(() => {
        setCookie("lwOpid", opid);
    }, [opid]);

    useEffect(() => {
        setCookie("lwSessionId", sessionId);
    }, [sessionId]);

    useEffect(() => {
        setCookie("lwMode", mode);
    }, [mode]);

    useEffect(() => {
        setCookie("lwDevice", device);
    }, [device]);

    useEffect(() => {
        setCookie("lwEnv", env);
    }, [env]);

    useEffect(() => {
        setCookie("lwServer", server);
    }, [server]);

    useEffect(() => {
        setCookie("lwJurisdiction", jurisdiction);
    }, [jurisdiction]);

    useEffect(() => {
        setCookie("lwHideRTP", hideRTP.toString());
    }, [hideRTP]);

    useEffect(() => {
        setCookie("lwClock", clock.toString());
    }, [clock]);

    useEffect(() => {
        setCookie("lwGrub", grub.toString());
    }, [grub]);

    useEffect(() => {
        const gameList = [];
        SG_GAMES.forEach((entry) => {
            if (authenticated || !entry.inDev) {
                gameList.push(entry.name + "_" + entry.OGSid);
            }
        });
        setGameList(gameList);
    }, [authenticated]);

    const launchGame = () => {
        if (game === "Select Game_0") {
            return alert("Whoops! You need to select a game you silly goose.");
        }

        const urlDomain = `https://ogs-gcm-eu-dev.nyxop.net/gcm/gcm-launcher/launcher.html?gameUrl=https%3A%2F%2F${env === "Forge" || !authenticated ? "crucibledev.net%2Fdev%2Fsg" : "nyx-ogs-2pp-int.s3.amazonaws.com%2Fhtml5"}%2Fgcmwrapper.html%3Fenvid%3Deur%26dev%3D1%26configurl%3Dhttps%3A%2F%2Fogs-gcm-eu-dev.nyxop.net%2Fgcm%2Fgcm-core%2Fgcm.js`;
        const urlGameid = `&gameid=${game.split("_")[0]}`;
        const urlSessionid = `&operatorid=${authenticated ? opid : 5}&sessionid=${mode === "demo" ? `Free%3ATestSession` : sessionId}`;
        const urlCurrency = `&currency=${authenticated ? currency : "GBP"}`;
        const urlLang = `&lang=${authenticated ? language : "en_gb"}`;
        const urlMode = `&mode=${mode}`;
        const urlSecure = `&secure=true`;
        const urlType = `&type=nextgen`;
        const urlClock = `&clock=${authenticated ? clock : false}`;
        const urlDevice = `&device=${authenticated ? device : "desktop"}`;
        const urlLobbyURL =
            authenticated && grub
                ? "&lobbyurl=https%3A%2F%2Fgrub.nyxaws.net"
                : `&lobbyurl=https://ogs-gcm-eu-dev.nyxop.net/gcm-lobby/launch.html`;
        const urlDepositURL = `&depositurl=`;
        const urlOgsgameid = `&ogsgameid=${game.split("_")[1]}`;
        const urlNyxroot = `&nyxroot=${authenticated ? server : SG_NYXROOT[0].code}`;
        const urlJurisdiction = `&jurisdiction=${authenticated ? jurisdiction : ".com"}`;
        const urlHideRTP = hideRTP && authenticated ? `&hidertp=${hideRTP}` : "";
        const urlGrub =
            grub && authenticated
                ? `&forcedOutcome=https%3A%2F%2Fcrucibledev.net%2Fdev%2Fsg%2F${game.split("_")[0]}_forces.csv`
                : "";

        let url =
            urlDomain +
            urlGameid +
            urlSessionid +
            urlCurrency +
            urlLang +
            urlMode +
            urlSecure +
            urlType +
            urlClock +
            urlDevice +
            urlLobbyURL +
            urlDepositURL +
            urlOgsgameid +
            urlNyxroot +
            urlJurisdiction +
            urlHideRTP +
            urlGrub;

        //Safari 3.0+ "[object HTMLElementConstructor]"
        const isSafari =
            /constructor/i.test(window.HTMLElement) ||
            (function (p) {
                return p.toString() === "[object SafariRemoteNotification]";
            })(!window["safari"] || (typeof safari !== "undefined" && window["safari"].pushNotification));

        if (isSafari) {
            window.open(url);
        } else {
            window.open(url, "_blank").focus();
        }
    };

    return (
        <main style={{ gap: "5rem" }}>
            <div className="dev-section">
                <h1>L&amp;W Launcher</h1>
                <div className="dev-container">
                    <div className="dev-item">
                        Game:
                        <br />
                        <select onChange={(e) => setGame(e.target.value)} value={game}>
                            {gameList.map((string) => (
                                <option key={string} value={string}>
                                    {string.split("_")[0]}
                                </option>
                            ))}
                        </select>
                    </div>
                    {authenticated && (
                        <>
                            <div className="dev-item">
                                Currency:
                                <br />
                                <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
                                    {SG_CURRENCY.map((option) => (
                                        <option key={option.code} value={option.code}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="dev-item">
                                Language:
                                <br />
                                <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                                    {SG_LANGUAGES.map((option) => (
                                        <option key={option.code} value={option.code}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="dev-item">
                                OPID:
                                <br />
                                <select value={opid} onChange={(e) => setOpid(e.target.value)}>
                                    {SG_OPIDS.map((option) => (
                                        <option key={option.label} value={option.id}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}
                    <div className="dev-item">
                        Mode:
                        <br />
                        <select value={mode} onChange={(e) => setMode(e.target.value)}>
                            <option value="demo">demo</option>
                            <option value="real">real</option>
                        </select>
                    </div>
                    <div className="dev-item">
                        SessionID:
                        <br />
                        <input value={sessionId} onChange={(e) => setSessionId(e.target.value)} />
                    </div>
                    {authenticated && (
                        <>
                            <div className="dev-item">
                                Device:
                                <br />
                                <select value={device} onChange={(e) => setDevice(e.target.value)}>
                                    <option value="desktop">desktop</option>
                                    <option value="mobile">mobile</option>
                                </select>
                            </div>
                            <div className="dev-item">
                                Launch Env:
                                <br />
                                <select id="SGEnv" name="SGEnv" onChange={(e) => setEnv(e.target.value)} value={env}>
                                    {SG_ENV.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="dev-item">
                                Server:
                                <br />
                                <select value={server} onChange={(e) => setServer(e.target.value)}>
                                    {SG_NYXROOT.map((option) => (
                                        <option key={option.code} value={option.code}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="dev-item">
                                Jurisdiction:
                                <br />
                                <select value={jurisdiction} onChange={(e) => setJurisdiction(e.target.value)}>
                                    {SG_JURISDICTION.map((option) => (
                                        <option key={option.code} value={option.code}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="dev-item flex-align-center" style={{ flexDirection: "row" }}>
                                <div
                                    className="dev-item flex-align-center"
                                    style={{
                                        padding: 0,
                                        background: "none",
                                        backdropFilter: "none",
                                        WebkitBackdropFilter: "none",
                                    }}
                                >
                                    Hide RTP:
                                    <br />
                                    <input
                                        type="checkbox"
                                        checked={hideRTP}
                                        onChange={(e) => setHideRTP(e.target.checked)}
                                    />
                                </div>
                                <div
                                    className="dev-item flex-align-center"
                                    style={{
                                        padding: 0,
                                        background: "none",
                                        backdropFilter: "none",
                                        WebkitBackdropFilter: "none",
                                    }}
                                >
                                    Clock:
                                    <br />
                                    <input
                                        type="checkbox"
                                        checked={clock}
                                        onChange={(e) => setClock(e.target.checked)}
                                    />
                                </div>
                                <div
                                    className="dev-item flex-align-center"
                                    style={{
                                        padding: 0,
                                        background: "none",
                                        backdropFilter: "none",
                                        WebkitBackdropFilter: "none",
                                    }}
                                    title="GRUB only works in Real Play - SessionID is required"
                                >
                                    GRUB:
                                    <br />
                                    <input type="checkbox" checked={grub} onChange={(e) => setGrub(e.target.checked)} />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="dev-item flex-align-center">
                        Launch!<br></br>
                        <button onClick={launchGame}>GO!</button>
                    </div>
                </div>
                {authenticated && (
                    <>
                        <span className="spacer"></span>
                        <h1>External Links</h1>
                        <div className="dev-container">
                            <a
                                className="external-item"
                                href="https://ogs-gut-gdk-cruciblesoftware-new.nyxaws.net/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                L&amp;W Game Upload Tool
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-gdm-gdk-cruciblesoftware-new.nyxaws.net/forcetool"
                                target="_blank"
                                rel="noreferrer"
                            >
                                L&amp;W Force Tool
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-gcm-eu-dev.nyxop.net/gcm-lobby/launch.html"
                                target="_blank"
                                rel="noreferrer"
                            >
                                OGS Game Launcher
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-bo-gdk-cruciblesoftware.nyxaws.net/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Crucible Back Office
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-bo-gdm-2pp-gamedev.nyxaws.net"
                                target="_blank"
                                rel="noreferrer"
                            >
                                2PP Generic Back Office - (nyx / nogs)
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-gdm-gdm-2pp-gamedev.nyxaws.net/forcetool"
                                target="_blank"
                                rel="noreferrer"
                            >
                                2PP Generic Force Tool
                            </a>
                            <a
                                className="external-item"
                                href="https://ogs-accountmock-0.nyxaws.net/admin/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Mock Wallet
                            </a>
                        </div>
                    </>
                )}
            </div>
        </main>
    );
};

export default LW;
